const isLocal = typeof window !== 'undefined'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname);

const API_URL = (process.env.REACT_APP_API_URL
  || (isLocal ? 'http://127.0.0.1:8007/api' : 'https://seashroud.precisionpros.com/api'))
  .replace(/\/$/, '');

const HUB_URL = (process.env.REACT_APP_HUB_URL
  || (isLocal ? 'http://localhost:3000' : 'https://games.precisionpros.com'))
  .replace(/\/$/, '');

export { API_URL, HUB_URL };

